// Small ISO date + time utilities used by the roster views.

export function toISO(d) {
    // Return YYYY-MM-DD in local time (no TZ shift)
    if (typeof d === "string") return d.slice(0, 10);
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

export function fromISO(iso) {
    const [y, m, d] = iso.split("-").map((n) => parseInt(n, 10));
    return new Date(y, m - 1, d);
}

export function addDays(d, n) {
    const x = new Date(d);
    x.setDate(x.getDate() + n);
    return x;
}

export function startOfWeek(d) {
    // Monday-start
    const x = new Date(d);
    const day = x.getDay(); // 0 Sun … 6 Sat
    const diff = (day + 6) % 7; // Mon = 0
    x.setDate(x.getDate() - diff);
    return x;
}

export function startOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
}

export function endOfMonth(d) {
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

const WEEKDAYS_LONG = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];
const WEEKDAYS_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS_LONG = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
const MONTHS_SHORT = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

function _toDate(input) {
    if (!input) return null;
    if (input instanceof Date) return input;
    if (typeof input === "string") {
        // Accept YYYY-MM-DD or ISO datetime
        const iso = input.length >= 10 ? input.slice(0, 10) : input;
        const [y, m, d] = iso.split("-").map((n) => parseInt(n, 10));
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d);
    }
    return null;
}

// Mon, 11-07-2026 (short weekday, DD-MM-YYYY)
export function formatShortDate(d) {
    const dt = _toDate(d);
    if (!dt) return "";
    return `${WEEKDAYS_SHORT[dt.getDay()]}, ${_ddmmyyyy(dt)}`;
}

// 11-07-2026 (no weekday)
export function formatDateOnly(d) {
    const dt = _toDate(d);
    if (!dt) return "";
    return _ddmmyyyy(dt);
}

function _ddmmyyyy(dt) {
    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yy = dt.getFullYear();
    return `${dd}-${mm}-${yy}`;
}

// Mon, 11-07-2026 (short weekday + DD-MM-YYYY) - alias
export function formatShortDateWithWeekday(d) {
    return formatShortDate(d);
}

// Monday, 11 July 2026
export function formatLong(d) {
    const dt = _toDate(d);
    if (!dt) return "";
    return `${WEEKDAYS_LONG[dt.getDay()]}, ${dt.getDate()} ${
        MONTHS_LONG[dt.getMonth()]
    } ${dt.getFullYear()}`;
}

// Mon (short weekday)
export function formatWeekday(d) {
    const dt = _toDate(d);
    if (!dt) return "";
    return WEEKDAYS_SHORT[dt.getDay()];
}

// Monday (long weekday)
export function formatWeekdayLong(d) {
    const dt = _toDate(d);
    if (!dt) return "";
    return WEEKDAYS_LONG[dt.getDay()];
}

export function fmtTime(t) {
    if (!t || !t.includes(":")) return t;
    const [hh, mm] = t.split(":").map((n) => parseInt(n, 10));
    const period = hh >= 12 ? "PM" : "AM";
    const h12 = hh % 12 === 0 ? 12 : hh % 12;
    return `${h12}:${String(mm).padStart(2, "0")} ${period}`;
}

export function isSameDay(a, b) {
    return (
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate()
    );
}

export function isBetweenISO(iso, startISO, endISO) {
    return iso >= startISO && iso <= endISO;
}
